// Barre de période globale, affichée sous la navigation sur toutes les pages.
// Elle pilote le store de dates partagé (voir stores/date-store.ts).

import { useDateStore } from "../stores/date-store";
import { formatDateFr } from "../lib/format";
import { DateRangePicker } from "./date-range-picker";

export function PeriodBar() {
  const { startDate, endDate, setDateRange } = useDateStore();
  return (
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-wrap items-center gap-x-4 gap-y-2">
        <span className="text-sm font-semibold text-gray-800">Période</span>
        <DateRangePicker appliedStart={startDate} appliedEnd={endDate} onApply={setDateRange} />
        <span className="text-xs text-gray-500">
          Bilan au {formatDateFr(endDate)} · P&amp;L, écritures et sync du {formatDateFr(startDate)} au{" "}
          {formatDateFr(endDate)}
        </span>
      </div>
    </div>
  );
}
